import { Link } from "react-router-dom";

type Props = { lang?: "en" | "tr" | "hi"; className?: string };

const TEXT = {
  en: ["I agree to the processing of my personal data in accordance with the ", "Privacy Policy", "."],
  tr: ["Kişisel verilerimin ", "Gizlilik Politikası", "'na uygun olarak işlenmesini kabul ediyorum."],
  hi: ["मैं ", "गोपनीयता नीति", " के अनुसार अपने व्यक्तिगत डेटा के प्रसंस्करण से सहमत हूँ।"],
};

export function ConsentCheckbox({ lang = "en", className = "" }: Props) {
  const [a, link, b] = TEXT[lang];
  return (
    <label className={`flex items-start gap-2 text-xs leading-relaxed opacity-80 ${className}`}>
      <input type="checkbox" name="privacy_consent" required className="mt-0.5 h-4 w-4 shrink-0 accent-current" />
      <span>
        <span>{a}</span>
        <Link to="/privacy" target="_blank" className="underline">
          {link}
        </Link>
        <span>{b}</span>
      </span>
    </label>
  );
}
